<template>
  <div>
    <h1>Empresas</h1>
    <b-row>
      <router-link :to="'./create/'">
        <b-button size="sm">{{ $t("geral.create") }}</b-button>
      </router-link>
    </b-row>

    <b-row>
      <b-table
        id="my-table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template v-slot:cell(id)="data">
          <router-link :to="'./edit/' + data.value">
            <b-button size="sm">{{ $t("geral.editar") }}</b-button>
          </router-link>
        </template>
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.filterKey">
              <div v-if="tableFilters[field.filterKey] != null">
                <b-form-input
                  v-if="
                    field.filterKey == 'startPlan' ||
                    field.filterKey == 'endPlan'
                  "
                  v-model="tableFilters[field.filterKey]"
                  type="date"
                  :placeholder="'Buscar por ' + field.label"
                />
                <b-form-select
                  v-else-if="field.filterKey == 'status'"
                  :options="statusOpt"
                  v-model="tableFilters[field.filterKey]"
                >
                </b-form-select>
                <b-form-input
                  v-else
                  v-model="tableFilters[field.filterKey]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </div>
            </b-th>
          </b-tr>
        </template>
      </b-table>
    </b-row>

    <b-row>
      <table-pagination-props
        :currentPage.sync="tableCurrentPage"
        :pageOptions.sync="tablePageOptions"
        :perPage.sync="tablePerPage"
        :rowCount.sync="tableRowCount"
      >
      </table-pagination-props>
    </b-row>
  </div>
</template>

<script>
import TablePaginationProps from "@/components_rms/base/TablePaginationProps.vue";
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";
import { computeEventEndResizable } from "@fullcalendar/core";
export default {
  name: "List",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    TablePaginationProps,
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "",
      },
      statusOpt: [
        { value: 0, text: "Todos" },
        { value: 1, text: "Ativo" },
        { value: 2, text: "Inativo" },
        { value: 3, text: "Bloqueado" },
      ],
      isBusy: false,
      fields: [
        {
          key: "id",
          sortable: false,
          label: "",
        },
        {
          key: "id",
          sortable: false,
          label: "",
        },
        {
          key: "numeroDocumento",
          filterKey: "numeroDocumento",
          label: "Numero Documento",
        },
        {
          key: "razaoSocial",
          filterKey: "razaoSocial",
          label: "Razao Social",
        },
        {
          key: "nomeFantasia",
          filterKey: "nomeFantasia",
          label: "Nome Fantasia",
        },
        {
          key: "planName",
          filterKey: "planName",
          label: "Plano",
        },
        {
          key: "startPlan",
          filterKey: "startPlan",
          label: "Início do plano",
        },
        {
          key: "endPlan",
          filterKey: "endPlan",
          label: "Fim do plano",
        },
        {
          key: "status",
          filterKey: "status",
          label: "Status",
          formatter: (value, key, item) => {
            if (value == 1) {
              return "Ativo";
            } else if (value == 2) {
              return "Inativo";
            } else if (value == 3) {
              return "Bloqueado";
            }
          },
        },
        // {
        //   key: "telefoneComercial",
        //   filterKey: "telefoneComercial",
        //   label: "Telefone Comercial",
        // },
        // {
        //   key: "celular",
        //   filterKey: "celular",
        //   label: "celular",
        // },
        // {
        //   key: "email",
        //   filterKey: "email",
        //   label: "email",
        // },
      ],
      computed: {},
      tableFilters: {
        numeroDocumento: "",
        razaoSocial: "",
        nomeFantasia: "",
        razaoSocial: "",
        telefoneComercial: "",
        celular: "",
        email: "",
        planName: "",
        startPlan: "",
        endPlan: "",
        status: 1,
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  methods: {
    myProvider(ctx) {
      this.isBusy = true;

      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        documentNumber: ctx.filter.numeroDocumento,
        corporateName: ctx.filter.razaoSocial,
        fantasyName: ctx.filter.nomeFantasia,
        commercialPhone: ctx.filter.telefoneComercial,
        cellPhone: ctx.filter.celular,
        email: ctx.filter.email,
        planName: ctx.filter.planName,
        startPlan: ctx.filter.startPlan,
        endPlan: ctx.filter.endPlan,
        status: ctx.filter.status,
      };
      // console.log(apiParam);
      return this.$apiScheduler
        .post("/empresa/all/", apiParam)
        .then((data) => {
          const items = data.data.items;
          console.log(items);
          this.isBusy = false;
          this.tableRowCount = data.data.totalItems;
          return items;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            console.logo(error.response);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            return [];
          }
        });
    },
  },
};
</script>

